import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { useId } from 'react';
import * as styles from './ai-gradient-sparkle-badge.css';
import { SPARKLE_FILLED_PATH } from '../ai-gradient-sparkle-path';

export function AiGradientSparkleBadge() {
  const reactId = useId();
  const gradientId = `ai-badge-gradient-${reactId.replace(/:/g, '')}`;

  return (
    <span className={styles.badge}>
      <svg width={12} height={12} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
        <defs>
          <linearGradient id={gradientId} x1="100%" y1="0%" x2="0%" y2="0%">
            <stop offset="0%" style={{ stopColor: themeVars.palette['orange-500'] }} />
            <stop offset="100%" style={{ stopColor: themeVars.palette['violet-600'] }} />
          </linearGradient>
        </defs>
        <path d={SPARKLE_FILLED_PATH} fill={`url(#${gradientId})`} />
      </svg>
    </span>
  );
}
